"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmericanHeartCms = void 0;
var AmericanHeartCms = /** @class */ (function () {
    function AmericanHeartCms() {
        this.imagePath = "/idpassets/buy/checkout/offers/AHA_LIWWG_red-and-black_RGB.png";
        this.mousehoverLabel = 'American Heart Association. Life Is Why We Give(TM).';
        this.descriptionLabel = "AT&T is a proud supporter of the American Heart Association\u2019s\n    Life Is Why We Give campaign to help fight heart disease and stroke. Donate today and help save lives.";
        this.description2Label = "<strong>100%</strong> of your gift goes directly to the American\n    Heart Association.";
        this.chooseDonationLabel = "<strong>Choose your one-time donation amount</strong>";
        this.donationAmountDescriptionLabel = "Your donation will be <strong>added to your first bill</strong>.";
        this.noDonationLabel = 'No donation';
        this.donationThankyouLabel = "Thank you! Your [[amount]] donation will be added to your first bill.";
    }
    return AmericanHeartCms;
}());
exports.AmericanHeartCms = AmericanHeartCms;
//# sourceMappingURL=AmericanHeartCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DonationOptionalPanel/AmericanHeartCms.cms.js
// module id = 972
// module chunks = 8